import { useState } from 'react';

import { useRepository } from '@/Application/Providers/Repository';
import { removeOutOfStockItems } from '@/modules/cart/application/removeOutOfStockItems';
import type { Cart } from '@/modules/cart/domain/Cart';
import type { MutatorHook } from '@/sections/shared/types/MutatorHook';

const useRemoveOutOfStockItems = (): MutatorHook<
  Cart['outOfStockItems'],
  void
> => {
  const { cart: cartRepository } = useRepository();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const trigger = async (outOfStockItems: Cart['outOfStockItems']) => {
    setIsLoading(true);
    try {
      if (outOfStockItems?.length) {
        await removeOutOfStockItems(cartRepository);
      }
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return { trigger, isLoading, error };
};

export default useRemoveOutOfStockItems;
